import BaseComponent from './BaseComponent.js'

export default class CozyYoutube extends BaseComponent {
  static get is() { return 'youtube' }

  get rootEl() { return 'iframe' }

  get styles() {
    return `
      :host {
        display: flex;
        justify-content: center;
        max-width: 100%;
        margin: 1em auto;
      }
      iframe {
        aspect-ratio: 16 / 9;
        width: 100% !important;
        height: auto !important;
      }
    `
  }

  mounted() {
    this.setComponentAttribute('title', 'YouTube Video')
    this.setComponentAttribute('frameborder', '0')
    this.setComponentAttribute('allowfullscreen', '')
    this.setComponentAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share')
  }

  get url() {
    const [id,time] = this.params
    return `https://www.youtube.com/embed/${id}?${time ? `start=${time}` : ''}`
  }

  updated() {
    this.setComponentAttribute('src', this.url)
  }


}
